module.exports = __webpack_public_path__ + "system/img/loading.4054c08a.gif";